/**
 * @file projectsUtils.js
 * @module components/Projects/projectsUtils
 * @summary Generates an inline SVG data URI to show when no real project
 * image is found.
 * @enterprise Used by ProjectCard's image onError handler as the final
 * fallback after both the theme/language-specific image and the English
 * default fail to load, so a project card never shows a broken-image icon.
 */

/**
 * Escapes the title to prevent SVG text injection.
 *
 * @param {string} title - Project name displayed inside the placeholder
 * @returns {string} data:image/svg+xml URI
 */
export const generatePlaceholderSVGDataUrl = (title) => {
  const safe = (title || 'Project').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const svg = `<?xml version="1.0" encoding="UTF-8"?><svg xmlns='http://www.w3.org/2000/svg' width='1200' height='675' viewBox='0 0 1200 675'><rect width='100%' height='100%' fill='%230f2238' rx='8'/><text x='50%' y='45%' fill='%239ec7ef' font-family='Arial, Helvetica, sans-serif' font-size='36' font-weight='600' text-anchor='middle'>Image not available</text><text x='50%' y='58%' fill='%237aa7d9' font-family='Arial, Helvetica, sans-serif' font-size='20' text-anchor='middle'>${safe}</text></svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
